import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">实时动态</h2>
          <p className="text-sm text-foreground-500">热点事件追踪，重要消息第一时间送达</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updateItems.map((item, idx) => (
              <div key={idx} className="flex items-start gap-5 pl-1">
                <div className="relative z-10 w-[38px] h-[38px] rounded-full bg-primary-100 border-2 border-primary-300 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className={`w-2.5 h-2.5 rounded-full ${idx === 0 ? 'bg-accent-500 animate-pulse' : 'bg-primary-400'}`}></div>
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.time}
                  </span>
                  <p className="text-sm md:text-base text-foreground-800 mt-2 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}